import { Outlet } from "react-router-dom";

const Blog = () => {
  return <Outlet />;
};

export default Blog;
